import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useUserProfile } from "@/hooks/useUserProfile";
import { toast } from "sonner";

// Listens to live changes on this user's purchases and surfaces a toast/banner
// when a refund, cancellation, or past-due event arrives via webhook.
export const usePurchaseNotifications = () => {
  const { user } = useUserProfile();

  useEffect(() => {
    if (!user?.email) return;
    const email = user.email.toLowerCase();

    const channel = supabase
      .channel(`purchase-notify-${user.id}`)
      .on(
        "postgres_changes",
        { event: "UPDATE", schema: "public", table: "purchases", filter: `user_email=eq.${email}` },
        (payload) => {
          const row = payload.new as { status?: string; notification_status?: string; plan_name?: string };
          const planLabel = row.plan_name ? ` (${row.plan_name})` : "";
          switch (row.notification_status) {
            case "refunded":
              toast.success(`Your refund has been processed${planLabel}. We've sent the details to your email.`, { duration: 8000 });
              break;
            case "canceled":
              toast.info(`Your subscription was cancelled${planLabel}. No further charges will be made.`, { duration: 8000 });
              break;
            case "payment_failed":
              toast.error(`A recurring payment failed${planLabel}. Please update your payment method to keep your access active.`, { duration: 10000 });
              break;
          }
        }
      )
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }, [user?.id, user?.email]);
};
